
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-projekte",
      function () {
        return require("private-next-pages/o-projekte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-projekte"])
      });
    }
  